const de = {
  alerts: {
    templateSaveFailed: 'Die Vorlage konnte nicht gespeichert werden',
    templateSaveSuccessful: 'Die Vorlage wurde erfolgreich gespeichert',
    loadError: 'Die Vorlage konnte nicht geladen werden'
  },
  templateNames: {
    orderSummary: 'Bestellbestätigung',
    returnReminder: 'Rückgabeerinnerung',
    collectionConfirmation: 'Abholbestätigung',
    cancelBookingForBorrower: 'Stornobestätigung',
    cancelBookingForLender: 'Verleiherstorno',
    newOrder: 'Neue Bestellung',
    articleSkuChange: 'ID-Änderung',
    bookingUpdate: 'Buchungsänderung'
  },
  templateNameLabel: 'Vorlagenname',
  templateNameHelperToLender: 'an Verleiher',
  templateNameHelperToBorrower: 'an Entleiher',
  templateDescription: {
    heading: 'Verwendbare Platzhalter',
    content:
      'Dieses Template wird für die automatisiert versendeten E-Mails verwendet. Zum Aufbauen des Templates können Sie die folgenden Platzhalter verwenden:'
  },
  templateVariables: {
    FULLNAME: 'Der volle Name des Empfängers',
    EMAIL: 'Die Email des Empfängers',
    TABLE: 'Die Übersicht der bestellten Artikel',
    STARTTIME: 'Das Datum der Bestellung'
  },
  toLeihbar: 'Zur leihBar'
};

export default de;
export type LeihbarMailSettingsTranslation = typeof de;
